import { jsx as _jsx } from "react/jsx-runtime";
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { css } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
const multiboxIconStyle = css `
    width: 100%;
    height: 100%;
    rect {
        fill: #f8f8f8;
        stroke: #dfdfdf;
    }
    position: absolute;
    z-index: -1;

    &:after {
        background: white;
        content: '';
        width: 100%;
        height: 100%;
        top: 3px;
        left: -5px;
        position: absolute;
        border-radius: 8px;
        border: 1px solid #dfdfdf;
    }
`;
export const DrawerThumbnailMultiboxIcon = observer(() => {
    const { asset: { status, isPresigned }, isMultiPage, } = useDrawerThumbnailAsset();
    if (!isMultiPage || (status.type !== AssetStatusType.Prepared && !isPresigned)) {
        return null;
    }
    return _jsx("div", { className: multiboxIconStyle, "data-testid": "multibox-icon" });
});
DrawerThumbnailMultiboxIcon.displayName = 'DrawerThumbnailMultiboxIcon';
//# sourceMappingURL=DrawerThumbnaillMultiboxIcon.js.map